import { useTranslation } from "react-i18next";

import SaveButton from "../../../components/Buttons/SaveButton";
import { useCanWrite } from "../../../utilities/helpers/roleUtilities";

type CopyPreviousHourButtonProps = {
  disabled: boolean;
  onCopy: () => Promise<boolean>;
};

const CopyPreviousHourButton: React.FC<CopyPreviousHourButtonProps> = ({ disabled, onCopy }) => {
  const { t } = useTranslation("production");
  const canCopy = useCanWrite("Digging.CopyTruckLoadsFromPreviousHour");

  if (!canCopy) return null;

  return (
    <div className="shrink-0">
      <SaveButton buttonLabel={t("trucksTable.copyPreviousHour")} disabled={disabled} handleSave={onCopy} />
    </div>
  );
};

export default CopyPreviousHourButton;
